import { useDispatch } from 'react-redux'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './dialogApprove.css'
import iconArrow from './iconArrow.svg'
import iconCircle from './iconCircle.svg'
import iconDolar from './iconDolar.svg'

import { iniApprovePpto } from '../../../redux/actions/pptos'

export const DialogApprove = ({ budgetId, type, open, setOpen }) => {

    const dispatch = useDispatch()

    const handleApprove = () => {
        dispatch(iniApprovePpto(budgetId, type))
        setOpen(false)
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>

                    {type === 'approve' ?
                        <>
                            <img src={iconCircle} alt="circle" />
                            <img src={iconArrow} alt="arrow" />
                            <img src={iconDolar} alt="dolar" />
                        </>
                        :
                        <>
                            <img src={iconDolar} alt="dolar" />
                            <img src={iconArrow} alt="arrow" />
                            <img src={iconCircle} alt="circle" />
                        </>
                    }

                </div>
                <div className='text'>
                    <h3>{type === 'approve' ? 'Confirmar aprobación' : 'Confirmar cancelación'}</h3>
                    {/* <p>¿Estás seguro que deseas realizar la acción</p>
                    <p>presupuesto?</p> */}
                </div>

                {type === 'approve' ?
                    <p className='p-text-emisor'>Esta acción dará por confirmado la venta</p>
                    :
                    <p className='p-text-emisor'>Esta acción dará por cancelado la venta</p>
                }

            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                {/* <button className='cancel' onClick={() => setOpen(false)}>Cancelar</button> */}
                <button className='approve' onClick={handleApprove}>{type === 'approve' ? 'Sí. Aprobar' : 'Sí, Confirmo'}</button>
            </DialogActions>
        </Dialog>
    );

}